import { Link } from '@amzn/awsui-components-react';

import FeedbackDropdown from '../../components/common/FeedbackDropdown';
import { constants } from '../Localization';
import { coreResources } from '../resourceConstants';

export interface HelpPanelFooterProps {
    pricingCalculator?: boolean,
    prescriptiveGuidancePrioritization?: boolean,
    prescriptiveGuidanceGrouping?: boolean,
    prescriptiveGuidanceWavePlanning?: boolean,
    prescriptiveGuidanceDataCollection?: boolean,
}

export const HelpPanelContentFooter = ( props: HelpPanelFooterProps ) => {
    const {
        pricingCalculator,
        prescriptiveGuidancePrioritization,
        prescriptiveGuidanceGrouping,
        prescriptiveGuidanceWavePlanning,
        prescriptiveGuidanceDataCollection,
    } = props;
    const pricingCalculatorContent = pricingCalculator ? (
        <li key='pricingCalculator'>
            <Link 
                external 
                href='https://calculator.aws/#/' 
                target='_blank'
                data-testid='pricingCalculator'
            >
                {constants.AWS_PRICING_CALCULATOR}
            </Link>
        </li>
    ) : null;

    const prescriptiveGuidancePrioritizationContent = prescriptiveGuidancePrioritization ? (
        <li key='prescriptiveGuidancePrioritization'>
            <Link 
                external
                href='https://docs.aws.amazon.com/prescriptive-guidance/latest/migration-portfolio-discovery/prioritization.html'
                target='_blank'
                data-testid='prescriptiveGuidancePrioritization'
            >
                {constants.PRESCRIPTIVE_GUIDANCE}
            </Link>
        </li>
    ) : null;

    const prescriptiveGuidanceGroupingContent = prescriptiveGuidanceGrouping ? (
        <li key='PRESCRIPTIVE_GUIDANCE'>
            <Link 
                external
                href='https://docs.aws.amazon.com/prescriptive-guidance/latest/migration-portfolio-discovery/planning.html#create_groups'
                target='_blank'
                data-testid='prescriptiveGuidanceGrouping'
            >
                {constants.PRESCRIPTIVE_GUIDANCE}
            </Link>
        </li>
    ) : null;

    const prescriptiveGuidanceWavePlanningContent = prescriptiveGuidanceWavePlanning ? (
        <li key='prescriptiveGuidanceWavePlanning'>
            <Link 
                external
                href='https://docs.aws.amazon.com/prescriptive-guidance/latest/migration-portfolio-discovery/planning.html#groups_to_plan'
                target='_blank'
                data-testid='prescriptiveGuidanceWavePlanning'
            >
                {constants.PRESCRIPTIVE_GUIDANCE}
            </Link>
        </li>
    ) : null;

    const prescriptiveGuidanceDataCollectionContent = prescriptiveGuidanceDataCollection ? (
        <li key='prescriptiveGuidanceDataCollection'>
            <Link 
                external
                href='https://docs.aws.amazon.com/prescriptive-guidance/latest/migration-portfolio-discovery/data-collection.html'
                target='_blank'
                data-testid='prescriptiveGuidanceDataCollection'
            >
                {constants.PRESCRIPTIVE_GUIDANCE}
            </Link>
        </li>
    ) : null;

    const coreResourceLinks = coreResources.map(resource => (
        <li key={`${resource.id}`}>
            <Link
                href={resource.href}
                target='_blank'
                data-testid={resource.id}
            >
                {resource.text}
            </Link>
        </li>
    ));

    const whatsNew = (
        <li key='whatsNew'>
            <Link
                href='/whats-new'
                target='_blank'
                data-testid='whatsNew'
            >
                {constants.WHATS_NEW}   
            </Link>
        </li>
    );
    return (
        <div>
            <h3>{constants.LEARN_MORE}</h3>
            <ul>
                {pricingCalculatorContent}
                {prescriptiveGuidancePrioritizationContent}
                {prescriptiveGuidanceGroupingContent}
                {prescriptiveGuidanceWavePlanningContent}
                {prescriptiveGuidanceDataCollectionContent}
                {coreResourceLinks}
                {whatsNew}
            </ul>
            <FeedbackDropdown buttonText={constants.FEEDBACK_HAVE_FEEDBACK} variant='primary' />
        </div>
    );
};
